import { memo } from "react";
import { ColorPicker, Slider, InputNumber, Switch, Divider } from "antd";
import styled from "styled-components";
import { LayerStyles, colorToHex } from "../types";

interface LabelStyleTabProps {
  styles: LayerStyles;
  onUpdate: (field: keyof LayerStyles['labels'], value: any) => void;
}

const LabelStyleTab = ({ styles, onUpdate }: LabelStyleTabProps) => {
  return (
    <StyleForm>
      <FormRow>
        <FormLabel>Hiển thị nhãn:</FormLabel>
        <Switch
          checked={styles.labels.enabled}
          onChange={(checked) => onUpdate('enabled', checked)}
        />
      </FormRow>

      <FormRow>
        <FormLabel>Màu chữ:</FormLabel>
        <ColorPicker
          value={styles.labels.color}
          onChange={(color) => onUpdate('color', colorToHex(color))}
          showText
          disabled={!styles.labels.enabled}
        />
      </FormRow>

      <FormRow>
        <FormLabel>Kích thước:</FormLabel>
        <Slider
          min={10}
          max={24}
          value={styles.labels.size}
          onChange={(value) => onUpdate('size', value)}
          style={{ flex: 1 }}
          disabled={!styles.labels.enabled}
        />
        <InputNumber
          min={10}
          max={24}
          value={styles.labels.size}
          onChange={(value) => onUpdate('size', value || 16)}
          style={{ width: 60 }}
          disabled={!styles.labels.enabled}
        />
      </FormRow>

      <Divider />

      <FormRow>
        <FormLabel>Màu viền chữ:</FormLabel>
        <ColorPicker
          value={styles.labels.haloColor}
          onChange={(color) => onUpdate('haloColor', colorToHex(color))}
          showText
          disabled={!styles.labels.enabled}
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ dày viền chữ:</FormLabel>
        <Slider
          min={0}
          max={3}
          step={0.2}
          value={styles.labels.haloWidth}
          onChange={(value) => onUpdate('haloWidth', value)}
          style={{ flex: 1 }}
          disabled={!styles.labels.enabled}
        />
        <span style={{ width: 60, textAlign: 'center' }}>
          {styles.labels.haloWidth.toFixed(1)}
        </span>
      </FormRow>

      <FormRow>
        <FormLabel>Zoom tối thiểu:</FormLabel>
        <Slider
          min={8}
          max={18}
          value={styles.labels.minZoom}
          onChange={(value) => onUpdate('minZoom', value)}
          style={{ flex: 1 }}
          disabled={!styles.labels.enabled}
        />
        <InputNumber
          min={8}
          max={18}
          value={styles.labels.minZoom}
          onChange={(value) => onUpdate('minZoom', value || 10)}
          style={{ width: 60 }}
          disabled={!styles.labels.enabled}
        />
      </FormRow>
    </StyleForm>
  );
};

export default memo(LabelStyleTab);

const StyleForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FormLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  min-width: 120px;
`;
